<template>
  <div>

    <b-row v-show="this.HasRights()">
      <b-card-code
        title="Fahrer"
        class="col-11 ml-1"
      >

        <!-- size -->
        <b-button-group
          size="sm"
          class="float-right mr-2"
        >
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            @click="LoadDrivers(365)"
          >
            365 Tage
          </b-button>
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            @click="LoadDrivers(30)"
          >
            30 Tage
          </b-button>
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            @click="LoadDrivers(14)"
          >
            14 Tage
          </b-button>
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            @click="LoadDrivers(7)"
          >
            7 Tage
          </b-button>
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            @click="LoadDrivers(1)"
          >
            Letzen 24h
          </b-button>
        </b-button-group>
        <div class="mt-3">
          <div id="chartDrivers"></div>
        </div>
      </b-card-code>
    </b-row>
  </div>
</template>

<script>
import ApexCharts from 'apexcharts'
import BCardCode from '@core/components/b-card-code'
import { BButtonGroup, BButton, BRow } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
export default {
  name: 'DriverStats',
  components: {
    BCardCode,
    BButtonGroup,
    BButton,
    BRow
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      chart: null
    }
  },
  async created() {
    await this.LoadDrivers(14);
  },
  methods: {
    HasRights() {
      return this.$store.state.user.Rights.includes('R2');
    },
    async LoadDrivers(days) {
      if(!this.HasRights())
        return;

      if(this.chart != null)
        this.chart.destroy()

      const options = {
        series: [
          {
            name: 'Fahrten',
            data: [],
            dataLabels: {
              enabled: true,
              formatter: function (val) {
                return val + '%' // Beschreibung für die zweite Serie
              }
            }
          },
          {
            name: 'Kilometer',
            data: []
          },
          {
            name: 'Umsatz',
            data: []
          },
          {
            name: 'Fahrzeit',
            data: []
          }],
        chart: {
          type: 'bar',
          height: 350
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '35%',
            endingShape: 'rounded'
          },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 3,
          colors: ['transparent']
        },
        xaxis: {
          categories: [],
        },
        fill: {
          opacity: 1
        },
      }

      const now2 = new Date()
      now2.setDate(now2.getDate() - days)
      const now = new Date()
      // Update the chart data with API response
      const resp = await this.$http.get(`/statistics/driver/hours?from=${now2.toISOString()}&to=${now.toISOString()}`);
      if (resp.data.success) {
        resp.data.statistics.forEach(i => {
          options.xaxis.categories.push(i.Driver.DriverShortName)
          options.series[0].data.push(i.Vouchers)
          options.series[1].data.push((i.Mileage/1000).toFixed(2))
          options.series[2].data.push(i.SalesVolume.toFixed(2))
          options.series[3].data.push((i.Hours/60/60).toFixed(2))
        })

        // this.NumberPlate = resp.data.vehicle.NumberPlate
      }

      this.chart = new ApexCharts(document.querySelector("#chartDrivers"), options);
      this.chart.render();
    },
  },
}
</script>

<style scoped>

</style>